import type { CategoryListResponseDataItemCustom } from '@twisto/api-cms'
import { Flex } from '@twisto/components/atoms/flex'
import { Typography } from '@twisto/components/atoms/typography'

import { CategoryPaper } from '../category-paper'

import { SectionHeader } from './section-header'
import { SubcategoryContentList } from './subcategory-content-list'
import * as styles from './subcategory-list.styles'

type Props = {
  categories?: CategoryListResponseDataItemCustom['attributes']['categories']
  categoryName: string
}

export const SubcategoryList = ({ categoryName, categories }: Props) => (
  <CategoryPaper>
    <Flex css={styles.subcategoryList} direction="column">
      <Typography
        color="textPrimary"
        component="h1"
        fontWeight="heavy"
        variant="h2"
      >
        {categoryName}
      </Typography>
      {categories?.map((category: CategoryListResponseDataItemCustom) => (
        <section key={category.id} css={styles.section}>
          <SectionHeader
            icon={category.icon}
            name={category.name}
            to={category.path}
          />
          <SubcategoryContentList {...category} />
        </section>
      ))}
    </Flex>
  </CategoryPaper>
)
